import React from 'react'
import PropTypes from 'prop-types'
import numeral from 'numeral'
import styles from './styles.css'

const Footer = props => {

  const {
    totals,
  } = props

  return (
    
    <div className={styles.wrapper}>

      <div className={styles.buttons}>
        {/* No edit buttons for subcontractors */}
      </div>

      <div className={styles.totals}>

        <div className={styles.total}>
          {`Total: £${numeral(totals.total).format('0,0.00')}`}
        </div>

      </div>

    </div>
    
  )

}

Footer.propTypes = {
  totals: PropTypes.object.isRequired,
}

export default Footer
